export default __webpack_public_path__ + "static/media/InstagramLogo.734a9564.png";